import { popModal } from '@/components/modals';

export type ViewDoctolibImportModalApi = {
  doctolibImportId: string;
  onClose?: () => void;
};

export const useViewDoctolibImportModalViewModel = ({
  api,
}: {
  api: Pick<ViewDoctolibImportModalApi, 'onClose'>;
}) => {
  return {
    api: {
      close: () => {
        api.onClose?.();
        popModal('ViewDoctolibImportModal');
      },
    },
  };
};
